import React from 'react';
import Hero from '../components/Hero';
import AboutPreview from '../components/AboutPreview';
import ServicesFull from '../components/ServicesFull';
import ServicesPreview from '../components/ServicesPreview';
import WhyChoose from '../components/WhyChoose';
import CTASection from '../components/CTASection';

const HomePage = () => {
  return (
    <>
      <Hero />
      <AboutPreview />
      <ServicesPreview />
      <ServicesFull />
      <WhyChoose />
      <CTASection />
    </>
  );
};

export default HomePage;
